import { render, staticRenderFns } from "./RateEdit.vue?vue&type=template&id=3405b06f&"
import script from "./RateEdit.vue?vue&type=script&lang=js&"
export * from "./RateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports